<template>
  <div class="container">
    <v-row>
      <v-col>
        <v-card class="mx-auto">
          <v-card-title>
            <h6 class="text--primary">
              India Total Cases: {{res.data.summary.total}}
              Total Deaths: {{res.data.summary.deaths}}
              <span
                style="color:red;"
                class="mdi mdi-arrow-up"
              ></span>
            </h6>
          </v-card-title>
          <v-card-text>
            <h6>
              Display Results By State
              <v-btn class="main-button float-right text-white" @click="goTo('/')" style="box-shadow:none; background:#0f754e;">
                Back
                <span style="color:#eee;" class="mdi mdi-arrow-left"></span>
              </v-btn>
            </h6>
            <!-- <v-card-text>
         Total Cases {{ res.data.regional}}
            </v-card-text>-->
            <!-- <v-card>
              <v-card-title>
                <div style="font-size:16px;" class="mx-auto">State</div>
                <div style="font-size:16px;" class="mx-auto">Confirmed</div>
              </v-card-title>
            </v-card>
            <v-card v-for="(item,idx) in res1.data.regional" :key="idx">
              <v-card-title>
                <div style="font-size:16px;" class="mx-auto">{{item.loc}}</div>
                <div style="font-size:16px;" class="mx-auto">{{item.totalConfirmed}}</div>
              </v-card-title>
            </v-card>-->
            <p>last Refreshed {{new Date(res.lastRefreshed).toLocaleString()}}</p>

            <v-simple-table fixed-header height="700px">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th
                      style="
      background:rgb(63, 61, 86); color:#eee"
                      class="text-left"
                    >State</th>
                    <th
                      style="
      background:rgb(63, 61, 86); color:#eee"
                      class="text-left"
                    >Confirmed</th>
                    <th
                      style="
      background:rgb(63, 61, 86); color:#eee"
                      class="text-left"
                    >Deaths</th>
                    <th
                      style="
      background:rgb(63, 61, 86); color:#eee "
                      class="text-left"
                    >Discharge</th>
       <th
                      style="
      background:rgb(63, 61, 86); color:#eee "
                      class="text-left"
                    >Active</th>

                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,idx) in res1.data.regional" :key="idx">
                    <td>{{ item.loc }}</td>
                    <td>{{ item.totalConfirmed }}</td>

                    <td>{{ item.deaths }}</td>

                    <td>{{ item.discharged }}</td>
                    <td>{{ item.totalConfirmed - item.discharged }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col>
        <v-card class="mx-auto" max-width="400">
          <v-img class="white--text align-end" src="img/undraw_medical_care_movn.svg">
            <v-card-title></v-card-title>
          </v-img>

          <v-card-subtitle class="pb-0">Number 10</v-card-subtitle>

          <v-card-actions>
            <v-btn color="orange" text>Precautionary Measures</v-btn>

            <v-btn color="orange" text>Explore</v-btn>
          </v-card-actions>
        </v-card>
        <v-card class="mx-auto mt-4" max-width="400">
          <v-img class="white--text align-end" src="img/undraw_medical_research_qg4d.svg">
            <v-card-title></v-card-title>
          </v-img>

          <v-card-subtitle class="pb-0">Number 10</v-card-subtitle>

          <v-card-actions>
            <v-btn color="orange" text>Precautionary Measures</v-btn>

            <v-btn color="orange" text>Explore</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { getCasesByState } from "../services/states";
export default {
  data() {
    return {
      res1: {
        data: {
          regional: null
        }
      },

      res: {
        lastRefreshed: null,
        data: {
          regional: null,
          summary: {
            total: null,
            deaths: null
          }
        }
      }
    };
  },
  methods: {
    async callApis() {
      console.log("fetched country list ");
      try {
        const res = await getCasesByState();
        console.log("all cases India List below : ", res);
        this.res = res;
        const res1 = await getCasesByState();
        console.log("all cases India List below : ", res1);
        this.res1 = res1;
      } catch (err) {
        console.log(err);
      }
    },
    goTo(path, params) {
      this.$router.push({
        path,
        params
      });
    }
  },
  mounted() {
    this.callApis();
  }
};

/* eslint-disable */
</script>
